<form *ngIf="form"
  [formGroup]="form">
  <ion-grid class="ion-no-padding">
    <ion-row class="mapfre-mt-m">
      <ion-col class="ion-no-padding"
        size="12">
        <span class="label mapfre-fs-xxs ">{{'REGISTER.CREATE_PASSWORD.PLACEHOLDERS.PASSWORD' | translate}}</span>
        <app-mapfre-input
          class="w-100"
          [type]="'password'"
          [placeholder]="'REGISTER.CREATE_PASSWORD.PLACEHOLDERS.PASSWORD' | translate"
          [control]="form.get('newPassword')"
          [showHintErrors]="true"
          (keypress)="alphaNumberOnly($event)"
          [hasErrors]="form.get('newPassword')?.dirty && form.get('newPassword')?.errors?.required"
          [errorText]="'INPUT_ERROR.DATA_IS_REQUIRED' | translate"
          [maxLength]="8"
        ></app-mapfre-input>
        <div class="mapfre-mt-xsm mapfre-mb-m">
          <div class="check-pass-content"
            *ngFor="let check of checksPassword">
            <span class="mapfre-fs-xs">{{check?.title | translate}}</span>
            <ion-icon *ngIf="!check.check()" class="check-pass-icon" name="checkmark-outline"></ion-icon>
            <ion-icon *ngIf="check.check()" class="check-pass-icon" name="close-outline"></ion-icon>
          </div>
        </div>
        <span class="label mapfre-fs-xxs"
          [ngClass]="{'df mapfre-mt-xsm' : form?.get('newPassword')?.valid || form?.get('confirmPassword')?.valid}"
        >
          {{'REGISTER.CREATE_PASSWORD.CHECK_PASSWORD_LABEL' | translate}}
        </span>
        <app-mapfre-input
          class="w-100"
          [type]="'password'"
          [placeholder]="'REGISTER.CREATE_PASSWORD.CHECK_PASSWORD_LABEL' | translate"
          [control]="form.get('confirmPassword')"
          [showHintErrors]="true"
          [hasErrors]="checkHasErrorsConfirmPassword()"
          (keypress)="alphaNumberOnly($event)"
          [errorText]="changeErrorTextConfirmPassword()"
          [disabled]="!form.get('newPassword')?.valid"
          [maxLength]="8"
          ></app-mapfre-input>
      </ion-col>
    </ion-row>
  </ion-grid>
</form>